import { render } from "./inputGroupAddons.vue?vue&type=template&id=d8f87d46&scoped=true"
import script from "./inputGroupAddons.vue?vue&type=script&lang=js"
export * from "./inputGroupAddons.vue?vue&type=script&lang=js"

import "./inputGroupAddons.vue?vue&type=style&index=0&id=d8f87d46&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src901110558/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f87d46"]])

export default __exports__